var _a;
import { COUNTRIES_SHORT } from "./countries.config";
export var PHONE_MASK = (_a = {},
    _a[COUNTRIES_SHORT.usa] = '(000) 000-0000',
    _a[COUNTRIES_SHORT.mexico] = '00 0000 0000',
    _a[COUNTRIES_SHORT.france] = '00 00 00 00 00',
    _a);
